import { useReducer } from 'react';
import type { EnrollmentData, EnrollmentAction } from '../context';

const INITIAL_DATA: EnrollmentData = {
  state: 'BANK_LINKING',
  contract: '',
  cpf: '',
  bankId: '',
  bankName: '',
  bankLogoUrl: '',
  registrationOptions: null,
  errorMessage: '',
  isAuthError: false,
  isTerminalError: false,
  intentUrl: '',
};

function enrollmentReducer(data: EnrollmentData, action: EnrollmentAction): EnrollmentData {
  switch (action.type) {
    case 'SET_CPF':
      return { ...data, cpf: action.cpf };

    case 'SET_BANK':
      return {
        ...data,
        bankId: action.bankId,
        bankName: action.bankName,
        bankLogoUrl: action.bankLogoUrl,
      };

    case 'START_INITIATION':
      return { ...data, state: 'INITIATING' };

    case 'INITIATION_SUCCESS':
      return {
        ...data,
        state: 'BANK_REDIRECT',
      };

    case 'START_POLLING':
      return { ...data, state: 'POLLING' };

    case 'REGISTRATION_OPTIONS_RECEIVED':
      return {
        ...data,
        state: 'READY_TO_AUTH',
        registrationOptions: action.registrationOptions,
        intentUrl: action.intentUrl,
      };

    case 'START_AUTHENTICATION':
      return { ...data, state: 'AUTHENTICATING' };

    case 'START_SUBMITTING_AUTH':
      return { ...data, state: 'SUBMITTING_AUTH' };

    case 'ENROLLMENT_SUCCESS':
      return { ...data, state: 'SUCCESS', intentUrl: action.intentUrl };

    case 'SET_ERROR':
      return { ...data, state: 'ERROR', errorMessage: action.errorMessage, isAuthError: false, isTerminalError: false };

    case 'SET_TERMINAL_ERROR':
      return { ...data, state: 'ERROR', errorMessage: action.errorMessage, isAuthError: false, isTerminalError: true, intentUrl: action.intentUrl };

    case 'SET_AUTH_ERROR':
      return { ...data, state: 'ERROR', errorMessage: action.errorMessage, isAuthError: true, isTerminalError: false };

    case 'RETRY':
      return { ...INITIAL_DATA, contract: data.contract, isTerminalError: false };

    case 'RETRY_AUTH':
      return { ...data, state: 'READY_TO_AUTH', errorMessage: '', isAuthError: false };

    default:
      return data;
  }
}

interface InitArgs {
  readonly contract: string;
  readonly step: string | null | undefined;
}

function init(args: InitArgs): EnrollmentData {
  return {
    ...INITIAL_DATA,
    state: args.step === 'polling' ? 'POLLING' : 'BANK_LINKING',
    contract: args.contract,
  };
}

export function useEnrollmentState(
  contract: string,
  step: string | null | undefined,
): [EnrollmentData, (action: EnrollmentAction) => void] {
  return useReducer(enrollmentReducer, { contract, step }, init);
}
